module.exports = __webpack_public_path__ + "static/media/icon_check_small_green.6daad607.svg";